function ensureFilterValueWithLabel(value) {
  if (value === void 0) {
    return void 0;
  }
  if (Array.isArray(value)) {
    return value.map(
      (v) => ensureFilterValueWithLabel(v)
    );
  }
  if (typeof value === "string") {
    return { value, label: value };
  }
  return value;
}

export { ensureFilterValueWithLabel };
//# sourceMappingURL=types.esm.js.map
